module.exports = __webpack_public_path__ + "e7531b2bfed8ac6b16007eecd8cd5c80.png";